import { cn } from '@/lib/utils';

export function TopicBreadcrumb({ topic }: { topic: string | null }) {
  if (!topic) {
    return (
      <div className="flex min-h-[28px] max-h-[28px] items-center overflow-hidden border-b border-(--color-border) bg-(--color-surface) px-2.5 py-[5px]">
        <span className="font-sans text-[0.692em] text-(--color-text3)">
          Select a topic to view messages
        </span>
      </div>
    );
  }
  const parts = topic.split('/');
  return (
    <div className="flex min-h-[28px] max-h-[28px] flex-wrap items-center gap-[3px] overflow-hidden border-b border-(--color-border) bg-(--color-surface) px-2.5 py-[5px]">
      {parts.map((p, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: path segments have no stable identity
        <span key={i} className="flex items-center gap-[3px]">
          <span
            className={cn(
              'rounded border px-[7px] py-[2px] font-mono text-[0.769em] font-bold',
              i === parts.length - 1
                ? 'border-(--color-green) bg-(--color-green-bg) text-(--color-green)'
                : 'border-(--color-border) bg-(--color-surface) text-(--color-text2)',
            )}
          >
            {p}
          </span>
          {i < parts.length - 1 && <span className="text-[0.692em] text-(--color-text3)">/</span>}
        </span>
      ))}
    </div>
  );
}
